module.exports = __webpack_public_path__ + "img/elumin-logo-white.ad44878d.svg";